import { useContext, useEffect, useState } from "react";
import UserContext from "../../hooks/UserContext";
import SatisfactionForm from "./satisfactionForm/SatisfationForm";
import { updateUser } from "../../scripts/user";


const FORMS = {
    SATISFACTION: 'SHOW_SATISFACTION_FORM',
}

const FeedbackForm = ({ }) => {
    
    const userContext = useContext(UserContext);
    const [showForm, setShowForm] = useState(userContext.user?.showForm);

    const closeFormCallback = async (state) => {
        setShowForm(state);

        userContext.setUser(prevUser => ({
            ...prevUser,
            showForm: null,
        }));

        const updatedUser = { userId: userContext.user.userId, showForm: null };
        await updateUser(updatedUser);
    }

    useEffect(() => {
        setShowForm(userContext.user?.showForm);
    }, [userContext.user?.showForm])

    
    return (<>
        {(showForm === FORMS.SATISFACTION) &&  <SatisfactionForm userContext={userContext} show={showForm === FORMS.SATISFACTION} setShow={(state) => closeFormCallback(state)} />} 
    </>)
}

export default FeedbackForm;